<template>
  <div class="search-conditions">
    <div class="row">
      <div class="col header" style="width:12%">
        <div class="subtitle">거래 날짜 / 시간 (시작)</div>
      </div>
      <div class="col header" style="width:12%">
        <div class="subtitle">거래 날짜 / 시간 (끝)</div>
      </div>
      <div class="col header" style="width:10%">
        <div class="subtitle"></div>
      </div>
      <div class="col header" style="width:10%">
        <div class="subtitle"></div>
      </div>
      <div class="col header" style="width:56%">
      </div>
    </div>

    <div class="row">
      <div class="col" style="width:12%">
        <date-picker
          type="datetime"
          v-model="startDateTime"
          input-class="datetime"
          style="width: 100%;"
          :show-second="false"
          format="YYYY.MM.DD HH:mm"
          :confirm="true"
          value-type="YYYY.MM.DD HH:mm"
        ></date-picker>
      </div>
      <div class="col" style="width:12%">
        <date-picker
          type="datetime"
          v-model="endDateTime"
          input-class="datetime"
          style="width: 100%;"
          :show-second="false"
          format="YYYY.MM.DD HH:mm"
          :confirm="true"
          value-type="YYYY.MM.DD HH:mm"
        ></date-picker>
      </div>

      <div class="col btn" style="width:10%">
        <button class="btn blue" @click="search">
          <img src="/static/img/ico-magnify.png" alt />
          검색
        </button>
      </div>
      <div class="col btn" style="width:10%">
        <button class="btn orange" @click="reset">
          <img src="/static/img/ico-renew@2x.png" alt />
          재고 등록
        </button>
      </div>
      <div v-if="device" class="col btn" style="width:10%">
        <button class="btn redpink" @click="openDevice">
          <img src="/static/img/ico-logout-white@2x.png" alt />
          문 열림
        </button>
      </div>
      <div class="col" style="width:40%">
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable no-useless-escape */
/* eslint-disable no-console */
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  components: {
    DatePicker,
  },
  props: [
    'device',
  ],
  data: () => ({
    startDateTime: null,
    startDate: {
      value: '',
      oldValue: null,
    },
    startTime: null,
    endDateTime: null,
    endDate: {
      value: '',
      oldValue: null,
    },
    endTime: null,
    searchCondition: '',
    today: null,
    limitDay: null,
  }),
  watch: {
    startDateTime: {
      handler() {
        if (this.startDateTime) {
          try {
            const splitDateTime = this.startDateTime.split(' ');
            this.startDate.value = splitDateTime[0];
            this.startTime = splitDateTime[1];
          } catch (e) {
            console.error(e);
          }
        }
      },
    },
    endDateTime: {
      handler() {
        if (this.endDateTime) {
          try {
            const splitDateTime = this.endDateTime.split(' ');
            this.endDate.value = splitDateTime[0];
            this.endTime = splitDateTime[1];
          } catch (e) {
            console.error(e);
          }
        }
      },
    },
  },
  methods: {
    numberAndDotFilter(data) {
      if (/^[\d\.]*$/.test(data.value)) {
        data.oldValue = data.value;
      } else if (data.oldValue) {
        data.value = data.oldValue;
      } else {
        data.value = '';
      }
    },
    search() {
      this.searchCondition = '';
      let startTime = '';
      let endTime = '';

      if (this.startDate.value) {
        if (!this.isValidDate(this.startDate.value)) {
          alert('올바른 시작 날짜를 입력하세요');
          return;
        }
        startTime = this.$moment(this.convertDate(this.startDate.value)).format();
      }
      if (this.startTime) {
        if (!this.startDate.value) {
          alert('시작 날짜를 입력하세요');
          return;
        }
        if (!this.isValidTime(this.startTime)) {
          alert('올바른 시작 시간을 입력하세요');
          return;
        }
        startTime = this.$moment(
          `${this.convertDate(this.startDate.value)} ${this.startTime}`,
        ).format();
      }

      if (this.endDate.value) {
        if (!this.isValidDate(this.endDate.value)) {
          alert('올바른 끝 날짜를 입력하세요');
          return;
        }
        endTime = this.$moment(`${this.convertDate(this.endDate.value)} 23:59:59`).format();
      }
      if (this.endTime) {
        if (!this.endDate.value) {
          alert('끝 날짜를 입력하세요');
          return;
        }
        if (!this.isValidTime(this.endTime)) {
          alert('올바른 끝 시간을 입력하세요');
          return;
        }
        endTime = this.$moment(
          `${this.convertDate(this.endDate.value)} ${this.endTime}:59`,
        ).format();
      }

      if (this.startDate.value < this.limitDay || this.endDate.value > this.today) {
        alert('최근 7일간의 결제건만 검색하실 수 있습니다.');
        return;
      }

      let searchCondition = '';
      if (startTime) {
        // searchCondition += `&from=${encodeURIComponent(startTime)}`;
        searchCondition += `&from=${encodeURIComponent(new Date(startTime).toISOString())}`;
      }
      if (endTime) {
        // searchCondition += `&to=${encodeURIComponent(endTime)}`;
        searchCondition += `&to=${encodeURIComponent(new Date(endTime).toISOString())}`;
      }

      this.searchCondition = searchCondition.replace('&', '');

      this.$emit('search', this.searchCondition);
    },
    isValidDate(date) {
      if (!/^\d{4}.\d{2}.\d{2}$/.test(date)) {
        return false;
      }

      const parts = date.split('.');
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10);
      const day = parseInt(parts[2], 10);

      if (month === 0 || month > 12) {
        return false;
      }

      const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

      if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
        monthLength[1] = 29;
      }

      return day > 0 && day <= monthLength[month - 1];
    },
    isValidTime(time) {
      if (!/^\d{2}:\d{2}$/.test(time)) {
        return false;
      }

      const parts = time.split(':');
      const hour = parseInt(parts[0], 10);
      const minute = parseInt(parts[1], 10);

      return hour >= 0 && hour < 24 && minute >= 0 && minute < 60;
    },
    convertDate(date) {
      const parts = date.split('.');
      const year = parts[0];
      const month = parts[1];
      const day = parts[2];
      let ret = year;
      ret += '-';
      ret += month;
      ret += '-';
      ret += day;
      return ret;
    },
    reset() {
      this.startDate.value = '';
      this.endDate.value = '';
      this.$emit('search', '');
    },
    async openDevice() {
      if (!this.device || !this.device.id) {
        return;
      }
      if (!confirm(`냉장고의 문을 여시겠습니까?\n  - 냉장고 이름: ${this.device.name}\n  - 냉장고 ID: ${this.device.id}`)) {
        return;
      }
      const ret = await this.$openDevice(this.device.id);
      if (!ret) {
        alert('냉장고 여는데 실패하였습니다.');
        return;
      }
      if (ret.response) {
        if (ret.response.status === 404) {
          alert('냉장고가 연결되어 있지 않습니다.');
          return;
        } else if (ret.response.status !== 200) {
          alert('냉장고 여는데 실패하였습니다.');
          return;
        }
      }
      if (ret.resultCode !== '0000') {
        alert('냉장고 여는데 실패하였습니다.');
      }
    },
  },
};
</script>

<style scoped>
.search-conditions {
  /* TODO */
  /* border: 3px solid green; */
  margin: 0px 0px 10px 310px;
}
.search-conditions .row {
  display: flex;
  height: 40px;
}
.search-conditions .row.space {
  margin-top: 48px;
}
.search-conditions .row .col {
  width: 100%;
  text-align: center;
}

.search-conditions .row .col:not(:last-child) {
  margin-right: 12px;
}

.search-conditions .row .col.header {
  text-align: left;
  margin-left: 10px;
  padding-top: 10px;
}
.search-conditions .row .col.btn {
  /* TODO max-width: 130px; */
  max-width: 100%;
}
.search-conditions .title {
  margin-bottom: 26px;
}
.search-conditions .subtitle {
  margin-bottom: 5px;
  font-size: 14.8px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.78;
  letter-spacing: 0.19px;
  color: #212121;
}
.search-conditions input {
  padding: 16px 8px 16px 16px;
  width: 100%;
  height: 100%;
  border: solid 0.5px #686868;
}
.search-conditions input::placeholder {
  font-size: 14.8px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.62;
  letter-spacing: 0.19px;
  color: rgba(72, 72, 72, 0.64);
}
.search-conditions .select {
  position: relative;
}
.search-conditions .select select {
  padding-left: 10px;
  width: 100%;
  height: 40px;
  border: solid 0.5px #686868;
  font-size: 14.8px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.62;
  letter-spacing: 0.19px;
}
.search-conditions .select img {
  position: absolute;
  width: 18px;
  height: 18px;
  top: 50%;
  right: 36px;
  transform: translate(0, -50%);
  cursor: pointer;
}
.search-conditions .btn {
  width: 100%;
  height: 40px;
  text-align: center;
  font-size: 12.8px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  color: #ffffff;
  border-radius: 2px;
  transition: 0.2s;
  cursor: pointer;
}
.search-conditions .btn img {
  width: 24px;
  height: 24px;
  vertical-align: middle;
}
.btn.blue {
  background-color: #0058EE;
}
.btn.blue .btn:hover {
  background-color: #0068fe;
}
.btn.orange {
  background-color: #FC8145;
}
.btn.orange .btn:hover {
  background-color: #FC8100;
}
.btn.redpink {
  background-color: #D01156;
}
.btn.redpink .btn:hover {
  background-color: #D01100;
}
</style>



// WEBPACK FOOTER //
// src/components/stock/SearchConditions.vue